<ul class="navbar-nav navbar-nav--main" role="tablist">
  <!-- Direct Menu Items (max 5) -->
  <ng-container *ngFor="let item of directMenuItems">
    <li class="nav-item" *svAccessPermission="item.accessBy">
      <a
        class="nav-link"
        [routerLink]="item.url"
        routerLinkActive="active"
        [routerLinkActiveOptions]="item.slug === 'HOME' ? {exact: true} : {}"
        type="button"
        role="button"
      >
        <ng-container *ngIf="item.slug === 'HOME'">
          <sv-icon
            iconClass="iconFont-home"
            containerClass="nav-link__icon"
          ></sv-icon>
          <span class="visually-hidden">
            <sv-locale-text
              [key]="item.labelKey"
              [extractKey]="true"
            ></sv-locale-text>
          </span>
        </ng-container>
        <ng-container *ngIf="item.slug !== 'HOME'">
          <sv-locale-text
            [key]="item.labelKey"
            [extractKey]="true"
          ></sv-locale-text>
        </ng-container>
      </a>
    </li>
  </ng-container>

  <!-- Other Apps Dropdown - Only show if there are items -->
  <li class="nav-item" *ngIf="dropdownMenuItems.length > 0">
    <div ngbDropdown class="dropdown-center">
      <button
        class="nav-link"
        [class.active]="isDropdownMenuActive()"
        ngbDropdownToggle
        [svHideCaret]="true"
        role="button"
        aria-expanded="false"
      >
        <sv-icon
          iconClass="iconFont-apps"
          containerClass="nav-link__icon"
        ></sv-icon>
        <span class="visually-hidden">Other</span>
      </button>
      <ul ngbDropdownMenu class="dropdown-menu">
        <ng-container *ngFor="let item of dropdownMenuItems">
          <li *svAccessPermission="item.accessBy">
            <a
              class="dropdown-item"
              [routerLink]="item.url"
              routerLinkActive="active"
              ngbDropdownItem
            >
              <sv-locale-text
                [key]="item.labelKey"
                [extractKey]="true"
              ></sv-locale-text>
            </a>
          </li>
        </ng-container>
      </ul>
    </div>
  </li>
</ul>
